// extracted by mini-css-extract-plugin
export default {"chartPlaceHolder":"Parking_chartPlaceHolder__LoPQK","chartLegend":"Parking_chartLegend__QbQ2I"};